import {RootState} from "../../../../store";

export const getRoomsIsLoadingRoom = (state: RootState) => state.roomsReducer.isLoadingRoom;
